import { LineMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/LineMarkerSidebar/LineMarkerStyleSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerCoordinatesSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerCoordinatesSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { useContext } from 'react';
import { ILineV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: ILineV2WorldMarker;
}

export const LineMarkerSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    return (
        <S_LineMarkerSidebar className={props.className}>
            <MarkerCoordinatesSection
                coordinates={props.marker.elementData.coordinates}
                onCoordinatesChange={(coordinates) => {
                    ctxEdit.updateWorldMarkerData(props.marker.id, { coordinates });
                }}
            />
            <LineMarkerStyleSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_LineMarkerSidebar>
    );
};

const S_LineMarkerSidebar = styled.div``;
